import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FullPageLoader } from '@/layouts/FullPageLoader';
import { useAuth } from '../context/AuthContext';

/**
 * Guarda de ruta: exige sesión autenticada. Mientras se restaura la sesión (cookie
 * de refresh) muestra un loader; si no hay sesión, redirige a `/login` recordando el
 * destino original.
 */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return <FullPageLoader />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return <Outlet />;
}

/** Guarda inversa: evita que un usuario autenticado vuelva a las pantallas de login. */
export function RedirectIfAuthenticated() {
  const { status } = useAuth();

  if (status === 'checking') {
    return <FullPageLoader />;
  }
  if (status === 'authenticated') {
    return <Navigate to="/noc" replace />;
  }
  return <Outlet />;
}
